import helpers from '../../util/helpers';

const searchEvents = () => {
  jQuery(document).ready(function($) {
    const page = $('html, body');

    // Guests Autocomplete
    const eventsSearch = $('input.events-search');
    if (eventsSearch.length) {
      eventsSearch.each(function() {
        const _this = $(this);

        _this.rsdAutocomplete({
          minimumInputLength: -1,
          data: _this.data('feed') ? _this.data('feed') : [],
          layout: 1,
          showListName: false,
        });
      });

      eventsSearch.on('click', function() {
        if (helpers.isMobile()) {
          page.on('scroll mousewheel touchmove', function() {
            page.stop();
          });

          page.animate({scrollTop: $(this).offset().top}, 'slow', function() {
            page.off('scroll mousewheel touchmove');
          });
        }
      });

      eventsSearch.on('input', function() {
        const _this = $(this);

        if (_this.data('cookie-event-types') && _this.val().length === 0) {
          helpers.docCookies.setItem(_this.data('cookie-event-types'), _this.val(), 1500, '/');
        }
      }).on('input_changed.rsd-ac', function() {
        const _this = $(this);

        if (_this.data('cookie-event-types')) {
          helpers.docCookies.setItem(_this.data('cookie-event-types'), _this.val(), 1500, '/');
        }
      });
    }
  });
};

export default searchEvents;



// WEBPACK FOOTER //
// ./scripts/routes/modules/searchEvents.js